// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageAndTextDisplayStyle_wrapper__SKDUA","slide":"ImageAndTextDisplayStyle_slide__joakH","headerWrapper":"ImageAndTextDisplayStyle_headerWrapper__koifS"};